<template>
  <f7-page>
    <div v-if="loaded">
      <navbar :text="`${$t('Configuration.name')} > ${$t('Configuration.Tasks_Title')} > ${$t('Configuration.Edit_Task')} `" />
      <Task-definition-form
        :activities="activities"
        :task-definition-detail="taskDefinitionDetail"
      />
      <f7-row>
        <f7-col>
          <f7-button
            class="dx-btn-cancel margin-right"
            raised
            type="default"
            text-color="grey"
            styling-mode="outlined"
            @click="goToTasks"
          >
            {{ $t("Go_Back") }}
          </f7-button>
        </f7-col>
        <f7-col>
          <f7-button
            class="dx-btn-success"
            raised
            type="success"
            styling-mode="contained"
            @click="editTask"
          >
            {{ $t("Button_save_text") }}
          </f7-button>
        </f7-col>
      </f7-row>
    </div>
  </f7-page>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import navbar from '../../../components/NavBar.vue';
import TaskDefinitionForm from '../../../components/configuration/tasks/taskDefinitionForm/index.vue';

export default {
  name: 'EditTaskDefinition',
  components: {
    navbar,
    TaskDefinitionForm,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState('TaskDefinition', ['activities', 'taskDefinitionDetail']),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      await this.fetchActivities();
      await this.getTaskDefinitionDetail();
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    } finally {
      this.loaded = true;
      this.$f7.preloader.hide();
    }
  },
  methods: {
    goToTasks() {
      this.$f7.views.main.router.navigate('/tasks/', { reloadCurrent: true });
    },
    async editTask() {
      if (this.taskDefinitionDetail.name === '') {
        this.$f7.dialog.alert(this.$t('Configuration.Name_validation'));
      } else if (this.taskDefinitionDetail.activity === '') {
        this.$f7.dialog.alert(this.$t('Configuration.Activity_validation'));
      } else {
        try {
          await this.editTaskDefinition();
        } catch (error) {
          this.$f7.dialog.alert(this.$t(`${error}`));
        } finally {
          this.$f7.views.main.router.navigate('/tasks/', { reloadCurrent: true });
        }
      }
    },
    ...mapActions('TaskDefinition', ['fetchActivities', 'getTaskDefinitionDetail', 'editTaskDefinition']),
  },

};
</script>
